function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export const Media = {
  image: {
    // eslint-disable-next-line id-length
    read(_, _ref) {
      let {
        readField
      } = _ref;
      const images = readField('images');
      if (!images || images.length === 0) {
        return null;
      }
      const primary = images.find(img => img.subType === 'PRIMARY');
      let image;
      if (primary) {
        image = primary;
      } else {
        const secondary = images.find(img => img.subType === 'SECONDARY');
        if (secondary) {
          image = secondary;
        } else {
          image = images[0];
        }
      }
      if (!image) return null;
      const {
        url,
        sizes
      } = image;
      if (!sizes) return null;
      let size;
      const index = (sizes || []).indexOf('1000');
      if (index > -1) {
        size = '1000';
      } else {
        size = sizes[(sizes === null || sizes === void 0 ? void 0 : sizes.length) - 1];
      }
      if (!size) {
        return null;
      }
      return _objectSpread(_objectSpread({}, image), {}, {
        url: url.replace(/<SIZE>/ig, size)
      });
    }
  }
};
//# sourceMappingURL=Media.js.map